<template>
  <div>
    <v-img
      :src="require('@/assets/explore/menu/mailbox.png')"
      width="70"
      @click="mail()"
      :class="'menu-item ' + (countMail ? 'shake' : '')"
    >
    </v-img>
    <ApiErrorDialog v-if="api.isError" :api="api" />
  </div>
</template>
      
  <script>
import { mapState } from "vuex";
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    countMail: 0,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
  }),
  created() {
    //
  },
  async mounted() {
    await this.checkMail();
  },
  methods: {
    async checkMail() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/mail/count";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
      };

      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };

      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.countMail = resp;
      };
      await this.$api.fetch(this.api);
    },
    mail() {
      this.$router.push({
        name: "PageExploreMail",
      });
    },
  },
};
</script>

<style scoped>
.shake {
  -webkit-animation: shake 2s infinite ease-in-out;
  -moz-animation: shake 2s infinite ease-in-out;
  -ms-animation: shake 2s infinite ease-in-out;
  -o-animation: shake 2s infinite ease-in-out;
  animation: shake 2s infinite ease-in-out;
}
@keyframes shake {
  0% {
    transform: rotate(0) scale(1) skew(1deg);
  }
  10% {
    transform: rotate(-25deg) scale(1) skew(1deg);
  }
  20% {
    transform: rotate(25deg) scale(1) skew(1deg);
  }
  30% {
    transform: rotate(-25deg) scale(1) skew(1deg);
  }
  40% {
    transform: rotate(25deg) scale(1) skew(1deg);
  }
  50% {
    transform: rotate(0) scale(1) skew(1deg);
  }
  100% {
    transform: rotate(0) scale(1) skew(1deg);
  }
}

.menu-item {
  cursor: pointer;
}

.menu-item:hover {
  scale: 1.1;
}
</style>